import { render, staticRenderFns } from "./trade.vue?vue&type=template&id=7a89e99c&scoped=true&"
import script from "./trade.vue?vue&type=script&lang=js&"
export * from "./trade.vue?vue&type=script&lang=js&"
import style0 from "./trade.vue?vue&type=style&index=0&id=7a89e99c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a89e99c",
  null
  
)

export default component.exports